<template>
<!-- 软件产品 -->
    <div>
        <div>
            <!-- 顶部图片 -->
            <div class="softTopImg">
                <div>
                    <span>围绕跨境电商场景独立开发的软件工具</span>
                </div>
            </div>
            <div class="YinShiBusiness">
                <div class="business">
                    <div class="businessImg1 businessIcon">
                        <img src="../../assets/img/softwareProduct/1.png" @click="showImgClick('1')"/>
                    </div>
                    <div class="businessTitle">仓储(WMS)系统</div>
                    <div class="businessContent textHide">
                        {{YinShiBusiness.content1}}
                    </div>
                </div>
                <div class="business">
                    <div class="businessImg2 businessIcon">
                        <img src="../../assets/img/softwareProduct/2.png" @click="showImgClick('2')"/>
                    </div>
                    <div class="businessTitle">订单系统</div>
                    <div class="businessContent textHide">
                        {{YinShiBusiness.content2}}
                    </div>
                </div>
                <div class="business">
                    <div class="businessImg3 businessIcon">
                        <img src="../../assets/img/softwareProduct/3.png" @click="showImgClick('3')"/>
                    </div>
                    <div class="businessTitle">物流系统</div>
                    <div class="businessContent textHide">
                        {{YinShiBusiness.content3}}
                    </div>
                </div>
                <div class="business">
                    <div class="businessImg4 businessIcon">
                        <img src="../../assets/img/softwareProduct/4.png" @click="showImgClick('4')"/>
                    </div>
                    <div class="businessTitle">比价系统</div>
                    <div class="businessContent textHide">
                        {{YinShiBusiness.content4}}
                    </div>
                </div>
                <div class="business">
                    <div class="businessImg5 businessIcon">
                        <img src="../../assets/img/softwareProduct/5.png" @click="showImgClick('5')"/>
                    </div>
                    <div class="businessTitle">销售工具</div>
                    <div class="businessContent textHide businessContent5">
                        {{YinShiBusiness.content5}}
                    </div>
                </div>
                <div class="business">
                    <div class="businessImg6 businessIcon">
                        <img src="../../assets/img/softwareProduct/6.png" @click="showImgClick('6')"/>
                    </div>
                    <div class="businessTitle">考核系统</div>
                    <div class="businessContent textHide">
                        {{YinShiBusiness.content6}}
                    </div>
                </div>
            </div>
            <el-dialog title="图片展示" :visible.sync="dialogVisible">
                <span><img :src="showImg" id="dimg"/></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteSoftwareProduct',
    data() {
        return {
            dialogVisible:false,
            showImg:'',
            YinShiBusiness:{
                content1:'包含仓储动态仓位、波次配货、点货/发货路径优化、自动化分拣、自动拍照称重等技术，实现仓储效率最优化，提升了整个仓储流程的自动化水平和可追溯性。 同时结合海外仓大批量发货的特性，单独开发了海外仓库间操作模块，支持多人任务协作，尺寸超标预警，装箱商品校验，等让整个操作流程化。有效保证了胤石向全球10余个海外仓库调拨的时效，且错误率基本为零。',
                content2:'胤石为全渠道垂直类电商公司，其ERP可以跨平台从订单同步、审核、分派，到订单履行过程中的状态跟踪、信息同步， 再到售后的退换货整体流程进行一体化的综合管理。 通过搭建信息系统，95%的平台订单都可以被系统自动处理，减少人为干预所带来的不确定性。双十一期间超六万的订单，整个订单部只需要2个人就可以轻松应对。海外仓订单更是可以做到全天候24小时无值守全自动发货，春节回家再也不用担心订单没人处理了',
                content3:'胤石公司通过API接口对接外部跨境物流供应商，及时获取物流信息，保证货物安全、高效地送达目的地。同时，通过运输方式管理、渠道管理、 偏远地区与分区管理、运费查询、分段运输方式管理等模块对运输方式、物流供应商价格等方面进行管理，实现物流成本最优。 胤石与万邑通、燕文、CNE、eBay橙联国际、俄罗斯J-NET，4PX, 亚马逊FBA，等都进行了深度API对接，操作者基本不需要登录物流平台，在ERP中就可以完成从货件创建到退货处理全流程货件操作，极大的提高了工作效率。',
                content4:'物流费占据电商成本30%以上，为减少这块成本的支出，胤石公司开发了订单自动比价系统。通过引入多家头尾程物流渠道商，在订单导入系统的同时，自动进行全渠道比价，并筛选出符合平台规则的最低物流报价。 整套系统在海外仓订单履行中同样发挥着重要的作用，系统可以根据客人的所在地(美东,美西,美中)， 自动匹配距离最近的发货仓库，并配以性价比最高的的尾程物流方式. 通过这套系统，可以为公司节约大概25%的物流派送费用。',
                content5:'销售模块主要用于协助销售上传、优化和推广产品，以实现对店铺的个性化、 智能化和自动化管理。上千条在线listing的增删改查尽在弹指一挥间。 其它销售工具还包含范本管理、自动运营、店铺管理、广告管理、等功能。其中“自动运营”模块是今年刚完成的项目，自动运营的原理是根据线上海量listing的曝光量，点击率，转化率，利润率等数据维度，以大数据算法为支撑，结合胤石多年的销售经验，自动生成最佳运营策略，协助运营人员高效店铺。随着数据磨合的不断深入，将让企业慢慢减弱对基础运营人员的依赖程度，让小白也能做出专业的活来',
                content6:'为管理一只庞大的销售队伍，胤石IT团队联合人事部门共同开发出智能考核系统，可根据团队属性不同，分为OKR，和KPI两个考核框架。其中OKR基于阿米巴模式，公司和员工类似于合伙人关系，以销售目标达成为导向，成本共担、利润共享，让员工为自己打工。 系统能智能分摊所有销售成本，并根据阿米巴财务报表编制准则，自动生成各阿米巴团队的单位时间附加值报表，每月的收支情况，每位成员的利润贡献情况，目标达成情况等关键数据全部了如指掌，大大降低了阿米巴系统实施对公司财务和人事成员的统计压力。',
            }
        };
    },
    mounted() {
        var child = document.querySelectorAll('.businessContent');
        var businessTitle = document.querySelectorAll('.businessTitle');
        var business = document.querySelectorAll('.business');
        var businessIcon = document.querySelectorAll('.businessIcon');
        child.forEach((item,index) => {
            item.addEventListener('mouseover', () => {
                businessTitle[index].style.display = 'none';
                businessIcon[index].style.display = 'none';
                business[index].style.backgroundColor = '#3b589a';
                // if(index == 4){
                    // document.querySelector('.businessContent5').classList.add('businessContent5Mover')
                // }
            });
            item.addEventListener('mouseout', () => {
                business[index].style.backgroundColor = '#fff';
                businessTitle[index].style.display = 'inline-block';
                businessIcon[index].style.display = 'inline-block';
                // if(index == 4){
                    // document.querySelector('.businessContent5').classList.remove('businessContent5Mover')
                // }
            });
        })
        // console.log(child)
    },
    methods: {
        ...mapMutations(['GoTop']),
        showImgClick(img) {
            this.showImg = require(`@/assets/img/softwareProduct/${img}.png`);
            this.dialogVisible = true; 
        }
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
    // 顶部图片
    .softTopImg{
        background: url(../../assets/img/softwareProduct/ruanjianchanpin_02.jpg);
        height: 650px;
        background-size:100% 650px;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            width: 715px;
            height: 146px;
            // padding:18px 66px;
            backdrop-filter: blur(3px);
            background-color: #000d5338;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                font-size: 36px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: center;
                color: #ffffff;
                line-height: 67px;
            }
        }
        
    }
    // 胤石
    .YinShiBusiness{
        padding:0px 270px 70px 270px;
        background: #eeeeee;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        // 每一个业务
        .business{
            width: 360px;
            height: 420px;
            padding:0px 30px 0px 30px;
            border-radius: 10px;
            background: #ffffff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 70px;
            transition: .4s all;
            cursor: pointer;
            .businessIcon{
                margin-top: -20px;
                width: 100%;
                img{
                    height: 100px;
                    width: 100%;
                    object-fit: contain;
                }
            }
            // 标题
            .businessTitle{
                margin-top: 40px;
                font-size: 18px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                color: #444444;
                transition: .5s all;
            }
            // 内容
            .businessContent{
                width: 350px;
                margin-top:30px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: center;
                -webkit-line-clamp:4;
                font-size: 16px;
                color: #555555;
                line-height: 32px;
                transition: .2s all;
            }
        }
        .businessMover{
            background: #3b589a;
        }
        .businessIconTitleMover{
            display: inline-block;
        }  
        .businessContent:hover{
            color:#fff !important;
            -webkit-line-clamp:99 !important;
            margin-top:0px;
        }
        .businessContent5Mover{
            font-size: 15px !important;
        }
    }
    #dimg{
        width:100%;
    }
</style>